// core
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

// campfire
import { PartnerBrandService } from '@campfire-nx/api';
// services
import { RaptorManagerService } from '@open-portal-app/core/services/raptor-manager.service';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  @Input() partnerBrandData: any;

  DEFAULT_DISCLAIMER = 'Oops, we couldn\'t fetch your disclaimer at this moment. We\'re working to resolve this as soon as possible. Please refer to the Product Disclosure Statement and Terms & Conditions of your policy for details.';

  showLegalInfo: boolean = true;
  hideDisclaimer: boolean = false;
  showHelp?: boolean;
  showProductDisclaimer?: boolean;
  ratorStepDataSubscription!: Subscription;
  termsLabel = 'Terms of use';

  constructor(
    private router: Router,
    public raptorManagerService: RaptorManagerService,
    private partnerBrandService: PartnerBrandService
  ) { }

  ngOnInit(): void {
    // Show help links if header is NOT loaded on help flow and dashboard
    const pathsWithNoHelpLinks = ['/support', '/dashboard'];
    const product = this.partnerBrandService.getAttribute('product', 'partner');
    const partnerName = this.partnerBrandService.getAttribute('name', 'partner');
    this.showHelp = !pathsWithNoHelpLinks.some((i) => this.router.url.includes(i));

    const pathsWithoutProductContext = ['/support', '/dashboard', '/emergency'];
    this.showProductDisclaimer = !pathsWithoutProductContext.some((i) => this.router.url.includes(i));

    this.ratorStepDataSubscription = this.raptorManagerService.step$
      .subscribe((data: any) => {
        this.showLegalInfo = data.formData.progress === 0;
      });
  }

  ngOnDestroy(): void {
    if (this.ratorStepDataSubscription) {
      this.ratorStepDataSubscription.unsubscribe();
    }
  }

  onShowLegalInfo(): boolean {
    this.showLegalInfo = true;
    return false;
  }
}
